<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-05-13 04:54:55
    Description : 富文本展示
  -->
  <div class="main">
    <gaia-header :isShowUpload="false" />
    <div style="height: 140px"></div>
    <div class="page about-page">
      <div class="gaiamount">
        <span class="red">Gaia</span>
        <span style="margin-right: 10px">mount</span>
        <span>{{ title[type] }}</span>
      </div>
      <div class="html" v-html="html" v-loading="loading"></div>
    </div>
    <gaia-footer />
  </div>
</template>

<script>
import GaiaFooter from "../components/gaia-footer/gaia-footer.vue";
import gaiaHeader from "../components/gaia-header/gaia-header.vue";
import { getHomeText } from "@/api/works";
import { getAgree, getRequire } from "@/api/newgaia48";
export default {
  components: { gaiaHeader, GaiaFooter },
  data() {
    return {
      html: "",
      type: 0,
      title: [
        "版权声明",
        "服务协议",
        "上传协议",
        "关于我们",
        "底部声明",
        "底部公告",
        "参赛协议",
        "成片要求",
      ],
      homeTextList: [],
      loading: true,
    };
  },
  created() {
    this.type = +this.$route.query.type;
    if (this.type < 6) {
      this.getHomeText();
    } else if (this.type === 6) {
      this.getAgree();
    } else if (this.type === 7) {
      this.getRequire();
    }
  },
  methods: {
    getHomeText() {
      getHomeText()
        .then((res) => {
          this.homeTextList = res.homeTextList;
          this.html = this.homeTextList[this.type].message;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getAgree() {
      getAgree()
        .then((res) => {
          this.html = res.otherInfo.content;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getRequire() {
      getRequire()
        .then((res) => {
          this.html = res.otherInfo.content;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1400px;
  background: #f5f5f5;
}
.about-page {
  width: 1200px;
  min-height: 600px;
  padding: 10px 40px 0;
  margin: 0 auto 100px;
  background: #ffffff;
  .el-input {
    margin-bottom: 10px;
  }
}
.gaiamount {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 20px;
  text-align: center;
  color: #000000;
  .red {
    color: #c00000;
  }
}
.html {
  min-height: 400px;
}
</style>